export enum DragItemType {
  PIECE = "piece",
}
